import { z } from "zod";

const contentItemSchema = z.object({
  text: z.string(),
  type: z.string(),
  status: z.enum(["info", "success", "error", "warning"]).nullable().optional(),
});

const contentSchema = z.object({
  content: z.array(contentItemSchema),
  version: z.string(),
});

export const commentSchema = z.object({
  id: z.string(),
  content: contentSchema,
  is_resolved: z.boolean(),
  resolved_at: z.string().nullable(),
  commentable_type: z.string(),
  commentable_id: z.string(),
  created_at: z.string(),
});

export type Comment = z.infer<typeof commentSchema>;
